<template>
<div class="ml-4 mb-4 mr-4">
  <div class="ew-profile-header">
        <navbar-dashboard name='Detalles De Envio'></navbar-dashboard>
  </div>
  <section class="mb-3 pt-2">
    <div class="ew-back-order">
      <router-link class="font-weight-bold alt-font h4" to="/shipments">
        <img src="@/assets/images/back-arrow.png" alt=""> Volver a órdenes
      </router-link>
    </div>

    <div class="ew-loading" v-if="dataLoading">
      <span class="ew-spinner"></span>
      <p class="ew-loading-text">Cargando envío…</p>
    </div>
    <div class="ew-empty" v-else-if="loadError">
      <ph-icon name="x" />
      <p class="ew-empty__title">No se pudo cargar el envío</p>
      <p class="ew-empty__text">Ocurrió un problema al consultar el servidor. Intenta de nuevo.</p>
      <button class="ew-btn-primary" @click="fetchShipment">Reintentar</button>
    </div>
    <div class="row" v-else-if="shipment">
      <div class="col-md-7 mb-2">
        
        
        <div class=" ew-white ew-box-shadow pl-2 pr-2 mb-1 ew-border-radius">
          <div class="ew-tabs font-weight-bold py-2">
            <div class="row align-items-center">
              <div class="col color-n1">Órden #{{ shipment.numberOfOrder }}</div>

              <div class="col-auto">
                <button type="button" class="btn btn-link p-0">
                  <img src="@/assets/images/Eliminar.svg" alt="">
                </button>
              </div>
            </div>
          </div>
          <section class="pb-2 pl-3 pr-3">
            <div class="row align-items-center">
              <div class="col-md font-weight-bold font-g1">Destino</div>

              <div class="col-md-auto">
                <router-link :to="'/shipments/' + shipment._id + '/edit/destination'" class="btn btn-link">Editar</router-link>
              </div>
            </div>

            <p class="text-black-50">{{ shipment.destination_direction.full_name }}</p>
            <p class="text-black-50">{{ shipment.destination_direction.email }}</p>
            <p class="text-black-50">{{ shipment.destination_direction.phone }}</p>
            <p class="text-black-50">{{ shipment.destination_direction.address }}</p>
            <p class="text-black-50">{{ shipment.destination_direction.colony }}</p>
            <p class="text-black-50">{{ shipment.destination_direction.postal_code }}</p>
            
          </section>
        </div>
        <div class="ew-white ew-box-shadow pl-2 pr-2 mb-1 ew-border-radius pt-2">
            <section class="pb-2 pl-3 pr-3" >
              <div class="row align-items-center">
                <div class="col font-weight-bold font-g1">Orígen</div>

                <div class="col-auto">
                  <router-link :to="'/shipments/' + shipment._id + '/edit/origin'" class="btn btn-link">Editar</router-link>
                </div>
              </div>

              <p class="text-black-50">{{ shipment.origin_direction.full_name }}</p>
              <p class="text-black-50">{{ shipment.origin_direction.email }}</p>
              <p class="text-black-50">{{ shipment.origin_direction.phone }}</p>
              <p class="text-black-50">{{ shipment.origin_direction.address }}</p>
              <p class="text-black-50">{{ shipment.origin_direction.colony }}</p>
              <p class="text-black-50">{{ shipment.origin_direction.postal_code }}</p>
            </section>
        </div>
        <div class="ew-white ew-box-shadow pl-2 pr-2 ew-border-radius pt-2">
          <section class="pb-2 pl-3 pr-3">
          <div class="row align-items-center">
            <div class="col font-weight-bold font-g1">Contenido de la órden</div>

            <div class="col-auto">
              <router-link :to="'/shipments/' + shipment._id + '/edit/description'" class="btn btn-link">Editar</router-link>
            </div>
          </div>

          <p class="text-black-50">{{ shipment.description_of_the_content }}</p>
        </section>
       
        </div>
        
      </div>
 
      <div class="col-md-5">
       
      <div class="ew-white ew-box-shadow pl-2 pr-2 mb-1 ew-border-radius">
        <div class="ew-tabs font-weight-bold py-2 color-n1">
          Servicio
        </div>
        <section class="pl-3 pr-3" >
          <div class="row align-items-center">
            <div class="col font-weight-bold font-g1">Proveedor</div>

            <div class="col-auto">
              <router-link :to="'/shipments/' + shipment._id + '/edit/service-provider'" class="btn btn-link">Editar</router-link>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-5">  
                <img :src="shipment.selected_service.carrier_logo_url_svg" alt="" class="img-fluid ">
            </div>
            

            <div class="col-sm-7 text-right">
              <p class="text-black-50">{{ shipment.selected_service.carrier_service_name }}</p>
              <p class="font-weight-bold h4">
                <small class="color-n2">{{ shipment.selected_service.currency }}</small> <span class="color-n2">{{ shipment.selected_service.total_amount }}</span></p>

            </div>
          </div>
          <div class="row align-items-center" v-if="shipment.number_guide">
            <div class="col font-weight-bold font-g1">Estatus de rastreo</div>
            <div class="col-auto text-black-50">
              <span v-if="trackingLoading">Consultando…</span>
              <span v-else>{{ trackingStatus || 'Sin verificar' }}</span>
            </div>
          </div>
        </section>
       </div>
        <div class="ew-white ew-box-shadow pl-2 pr-2 ew-border-radius pt-2">
          <section class="pl-3 pr-3">
          <div class="row align-items-center">
            <div class="col font-weight-bold font-g1">Información del paquete</div>

            <div class="col-auto">
              <router-link :to="'/shipments/' + shipment._id + '/edit/parcels'" class="btn btn-link">Editar</router-link>
            </div>
          </div>

          <section v-for="(p, i) in shipment.parcels" v-bind:key="i">
            <p class="text-black-50">Dimensiones</p>
            <p class="text-black-50">{{ p.height }} x {{ p.width }} x {{ p.depth }} cm</p>

            <p class="text-black-50">Peso</p>
            <p class="text-black-50">{{ p.weight }} kg</p>

            <p class="text-black-50">Peso Volumetrico</p>
            <p class="text-black-50">{{ volumetricWeight(p.height, p.width, p.depth) }} kg</p>
          </section>
          <hr>
        </section>

        <section class="pl-3 pr-3 pt-2 pb-2">
          <div class="mb-2">
            <div class="font-weight-bold font-g1">Total a Pagar</div>
          </div>
          <div class="col">
              <div class="row">
                <div class="col d-flex px-0 align-items-center ">
                    <div class="text-left text-primary font-weight-bold h4">
                      <small>{{shipment.selected_service.currency}} </small>{{ shipment.selected_service.total_amount }}
                    </div>
                </div>
                <div class="col-auto">
                  <span v-if="shipment.status" class="ew-badge ew-badge--success">Pagado</span>
                  <router-link v-if="!shipment.status" class="ew-btn-primary" :to="'/payments/' + shipment._id">Pagar</router-link>
                </div>
              </div>
            </div>
        </section>
        </div>        
      </div>
      

      </div>
  </section>
</div>
</template>

<script>
import axios from 'axios'
import Navbar from './Header/Navbar'
import { mapGetters } from 'vuex'
import commons from '../commons'
import PhIcon from './icons/PhIcon'

export default {
  name: 'Dashboard',
  data () {
    return {
      shipmentId: '',
      shipment: null,
      dataLoading: true,
      loadError: false,
      trackingStatus: null,
      trackingLoading: false
    }
  },
  created () {
    this.shipmentId = this.$route.params.id
    this.fetchShipment()
  },
  methods: {
    fetchShipment () {
      this.dataLoading = true
      this.loadError = false
      this.getShipment(this.shipmentId)
        .then(response => {
          this.shipment = response.data
          if (this.shipment && this.shipment.number_guide) {
            this.fetchTrackingStatus()
          }
        })
        .catch(error => {
          console.error(error)
          this.loadError = true
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    getShipment (id) {
      const url = `${commons.apiURL}/api/v1/shipments/${id}`
      return axios.get(url, { timeout: 30000 })
    },
    fetchTrackingStatus () {
      // Se pide solo al abrir el detalle, nunca en los listados — el
      // servidor además cachea el resultado por 24h por guía, así que
      // esto no vuelve a llamar al carrier si ya se consultó hoy.
      this.trackingLoading = true
      axios
        .get(`${commons.apiURL}/api/v1/tracking/shipment-status/${this.shipmentId}`, { timeout: 30000 })
        .then(response => {
          this.trackingStatus = response.data.status
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.trackingLoading = false
        })
    },
    volumetricWeight (height, width, depth) {
      return height * width * depth / 5000
    }
  },
  computed: {
    ...mapGetters(['shipments']),
    shipmentWithGuide () {
      return []
    },
    shipmentWithoutGuide () {
      return []
    }
  },
  components: {
    'navbar-dashboard': Navbar,
    'ph-icon': PhIcon
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/variables";
@import "../assets/styles/ew-components";

.ew-loading { @include ew-loading; }
.ew-loading-text { @include ew-loading-text; }
.ew-spinner { @include ew-spinner; }
.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-badge {
  display: inline-flex;
  align-items: center;
  height: 1.6rem;
  padding: 0 0.7rem;
  border-radius: 999px;
  font-family: var(--app-font);
  font-size: 0.75rem;
  font-weight: 700;

  &--success { background: rgba(26, 127, 79, 0.12); color: #1a7f4f; }
}

.ew-tabs{
  border-bottom: 1px solid #e7e7e7;
}
.color-n1{
  color: #f63a0e;
  font-size: 1.2rem;
}
.color-n2{
  color: #f63a0e;
}
.tm1{
  margin-bottom: 7px;
  padding-bottom: 0.7rem;
}
.box-1{
  border-top: 2px solid #b9b9b9;
}
.background-box1{
  background: #f7f7f7;
  padding: 5px 20px;
}

.ew-background-whith{
  background: #ffffff;
  padding: 5px 20px;
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.16); 
  
}
hr {
    margin-top: 1.5rem;
    margin-bottom: 0rem;
}
.text-black-50 {
    color: #262626!important;
    margin-bottom: 0.2rem;
}
.font-g1{
  font-size: 1.2rem;
}
.btn-link {
    font-weight: 400!important;
}
.field-in1{
    background: #ededed;
    padding: 0.3rem 0.5rem;
    height:32px;
}
.pbt1{
  padding-bottom: 1.2rem;
}
.ew-back-order{
  margin-bottom: 1rem;
 
}

.ew-back-order{
  a:hover{
     text-decoration: none;
     color: #262626;
  }
}

@media (min-width: 576px) { 
  .ew-container-edit{
    margin-left: auto;
    margin-right: auto;
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) { 
  .ew-container-edit{
    margin-left: auto;
    margin-right:auto;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) { 
  .ew-container-edit{
    margin-left: 3rem;
    margin-right: 3rem;
  }
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) { 
  .ew-container-edit{
    margin-left: 7rem;
    margin-right: 7rem;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/ShipmentDetails.vue